import React from "react";
import {
  Card,
  Typography,
  Button,
  Grid,
  Box,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

const MainContentCard1 = ({ title, md, abc, ssf, ml }) => {
  const navigate = useNavigate();

  const handleReadMore = () => {
    if (title === "Starter") {
      navigate("/starterAccount");
    } else if (title === "Pro Trader") {
      navigate("/proTraderAccount");
    } else if (title === "Zero Spread") {
      navigate("/zeroSpreadAccount");
    } else if (title === "Elite") {
      navigate("/eliteAccount");
    } else {
      navigate("/");
    }
  };

  return (
    <Card
      sx={{
        width: "240px",
        backgroundColor: "#fff",
        borderRadius: "16px",
        boxShadow: "0 4px 20px rgba(0, 0, 0, 0.08)",
        overflow: "hidden",
        position: "relative",
        transition: "all 0.3s ease",
        border: "1px solid transparent",
        "&:hover": {
          boxShadow: "0 12px 34px rgba(29, 44, 97, 0.2)",
          transform: "translateY(-6px)",
          borderColor: "rgba(58, 90, 168, 0.3)",
        },
      }}
    >
      {/* Slanted Diagonal Ribbon Header */}
      <Box
        sx={{
          position: "relative",
          background: "linear-gradient(135deg, #172543 0%, #1d2c61 100%)",
          height: "60px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          clipPath: "polygon(0 0, 100% 0, 100% 70%, 0 100%)",
          "&::after": {
            content: '""',
            position: "absolute",
            bottom: 0,
            left: 0,
            width: "40%",
            height: "4px",
            background: "var(--highlight-gradient)",
          },
        }}
      >
        <Typography
          sx={{
            color: "white",
            fontWeight: "700",
            fontSize: "1.1rem",
            textTransform: "uppercase",
            letterSpacing: "2px",
          }}
        >
          {title}
        </Typography>
      </Box>

      {/* Content Rows */}
      <Box sx={{ pt: "15px", px: "20px", pb: "10px" }}>
        <Grid container justifyContent="space-between" sx={{ py: "12px", borderBottom: "1px solid #eee" }}>
          <Grid item>
            <Typography sx={{ color: "#888", fontSize: "13px" }}>Min Deposit</Typography>
          </Grid>
          <Grid item>
            <Typography sx={{ color: "#333", fontSize: "13px", fontWeight: "600" }}>{md}</Typography>
          </Grid>
        </Grid>

        <Grid container justifyContent="space-between" sx={{ py: "12px", borderBottom: "1px solid #eee" }}>
          <Grid item>
            <Typography sx={{ color: "#888", fontSize: "13px" }}>Currencies</Typography>
          </Grid>
          <Grid item>
            <Typography sx={{ color: "#333", fontSize: "13px", fontWeight: "600" }}>{abc}</Typography>
          </Grid>
        </Grid>

        <Grid container justifyContent="space-between" sx={{ py: "12px", borderBottom: "1px solid #eee" }}>
          <Grid item>
            <Typography sx={{ color: "#888", fontSize: "13px" }}>Spreads From</Typography>
          </Grid>
          <Grid item>
            <Typography sx={{ color: "#333", fontSize: "13px", fontWeight: "600" }}>{ssf}</Typography>
          </Grid>
        </Grid>

        <Grid container justifyContent="space-between" sx={{ py: "12px" }}>
          <Grid item>
            <Typography sx={{ color: "#888", fontSize: "13px" }}>Max Leverage</Typography>
          </Grid>
          <Grid item>
            <Typography sx={{ color: "#333", fontSize: "13px", fontWeight: "600" }}>{ml}</Typography>
          </Grid>
        </Grid>
      </Box>

      {/* Button */}
      <Box sx={{ p: "15px", display: "flex", justifyContent: "center" }}>
        <Button
          onClick={handleReadMore}
          sx={{
            background: "var(--accent-gradient)",
            color: "white",
            padding: "10px 40px",
            borderRadius: "25px",
            fontWeight: "600",
            fontSize: "12px",
            textTransform: "uppercase",
            letterSpacing: "1px",
            boxShadow: "0 4px 14px rgba(29, 44, 97, 0.3)",
            transition: "transform 0.2s ease, box-shadow 0.2s ease",
            "&:hover": {
              transform: "translateY(-2px)",
              boxShadow: "0 6px 18px rgba(29, 44, 97, 0.45)",
            }
          }}
        >
          Read More
        </Button>
      </Box>
    </Card>
  );
};

export default MainContentCard1;
